import { Component, HostListener, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
// import {
//   SalaryIncrementComponent,
//   SalaryIncrementDialog,
// } from '../../../../../salary-increment/salary-increment.component';
import { ActivatedRoute } from '@angular/router';
import { AgGridAngular } from 'ag-grid-angular';
import { ColDef } from 'ag-grid-community';
import { EmployeeService } from '../../../../../../features/employees/employee.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-salary-details-profile',
  standalone: true,
  imports: [CommonModule, AgGridAngular, MatDialogModule],
  templateUrl: './salary-details-profile.html',
  styleUrl: '../../../../employee-details.component.scss',
  providers: [DatePipe]
})
export class SalaryDetailsProfileComponent {
  
  @Input() employeeData: any;
  employeeId: any;
  search: any;
  readonly dialog = inject(MatDialog);
  public viewPortSize: boolean = false;
  public themeClass: string = 'ag-theme-quartz';
  public loading: boolean = false;
  public rowData: any[] = [];
  columnDefs: any[] = [];

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkViewportSize();
  }

  checkViewportSize() {
    if (window.innerWidth > 1200) {
      this.viewPortSize = true;
    } else {
      this.viewPortSize = false;
    }
    this.setAGColumn();
  }

  setAGColumn() {
    this.columnDefs = [
      // { headerName: 'Employee Name', field: "employee", flex: this.viewPortSize ? 1 : 0 },
      {
        headerName: 'Increment Date',
        field: 'incrementDate',
        flex: this.viewPortSize ? 1 : 0,
      },
      {
        headerName: 'Old Salary',
        field: 'oldSalary',
        flex: this.viewPortSize ? 1 : 0,
        valueFormatter: (params: any) => {
          const value =
            params.value === null || params.value === 0 || params.value === ''
              ? 0
              : parseFloat(params.value);
          return value === 0 ? '' : `AED ${value.toFixed(2)}`;
        },
      },
      {
        headerName: 'New Salary',
        field: 'newSalary',
        flex: this.viewPortSize ? 1 : 0,
        valueFormatter: (params: any) => {
          const value =
            params.value === null || params.value === 0 || params.value === ''
              ? 0
              : parseFloat(params.value);
          return value === 0 ? '' : `AED ${value.toFixed(2)}`;
        },
      },
      {
        headerName: 'Increment Allowance',
        field: 'incrementAllowance',
        flex: this.viewPortSize ? 1 : 0,
        valueFormatter: (params: any) => {
          const value =
            params.value === null || params.value === 0 || params.value === ''
              ? 0
              : parseFloat(params.value);
          return value === 0 ? '' : `AED ${value.toFixed(2)}`;
        },
      },
      {
        headerName: 'Increment Basic',
        field: 'incrementBasic',
        flex: this.viewPortSize ? 1 : 0,
        valueFormatter: (params: any) => {
          const value =
            params.value === null || params.value === 0 || params.value === ''
              ? 0
              : parseFloat(params.value);
          return value === 0 ? '' : `AED ${value.toFixed(2)}`;
        },
      },
    ];
  }

  public defaultColDef: ColDef = {
    filter: 'agTextColumnFilter',
    floatingFilter: true,
  };
  public paginationPageSize = 10;
  public paginationPageSizeSelector: number[] | boolean = [10];
  public error: any = null;

  constructor(
    private route: ActivatedRoute,
    private employeeService: EmployeeService,
    private datePipe: DatePipe
  ) // private dialog: MatDialog
  {}

  ngOnInit() {
    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.employeeId = id;
      this.salaryHistories(this.employeeId);
    }
  }

  salaryHistories(id: number, search: any = '') {
    this.employeeService.salaryHistories(Number(id), search).subscribe({
      next: (data) => {
        this.rowData = data.map((log: any) => ({
          // employee: log?.employee?.firstName +  log?.employee?.lastName || '--',
          oldSalary: log?.oldSalary || '--',
          newSalary: log?.newSalary || '--',
          // incrementDate: log?.incrementDate || '--',
          incrementDate: log?.incrementDate 
          ? this.datePipe.transform(log.incrementDate, 'dd/MM/yyyy') 
          : '--',
          incrementAllowance: log?.incrementAllowance || '--',
          incrementBasic: log?.incrementBasic || '--',
        }));
      },

      error: (error) => {
        console.error('Error fetching salary history:', error);
      },
    });
  }

  addSalaryIncrement() {
    // const dialogRef = this.dialog.open(SalaryIncrementDialog, {
    //   data: {
    //     employeeId: this.employeeId,
    //   },
    //   disableClose: true,
    // });

    // dialogRef.afterClosed().subscribe((result) => {
    //   this.salaryHistories(this.employeeId);
    // });
  }

  formatCurrency(value: any): string {
    const val = parseFloat(value);

    if (isNaN(val) || value === null || value === undefined || value === '') {
      return '--';
    }

    return val === 0 ? '' : `AED ${val.toFixed(2)}`;
  }
}
